import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MobileVerificationComponent } from './Modules/mobile-verification/mobile-verification.component';
import { OtpVerificationComponent } from './Modules/otp-verification/otp-verification.component';
import { CarListComponent } from './Modules/car-list/car-list.component';
import { CarServiceComponent } from './Modules/car-service/car-service.component';
import { ConfirmBookingComponent } from './Modules/confirm-booking/confirm-booking.component';
import { BookingSummaryComponent } from './Modules/booking-summary/booking-summary.component';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ModalService } from './Shared/services';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from './Shared/directives/modal.component';
import { MgDecimalValuePipe } from './Shared/pipe/decimalValue';
import { NumberDirective } from './Shared/directives/numbers-only.directive';
import { DealerDetailComponent } from './Shared/component/dealer-detail/dealer-detail.component';
import { DealerLocationComponent } from './Shared/component/dealer-location/dealer-location.component';
import { DealerListComponent } from './Shared/component/dealer-list/dealer-list.component';
import { RentalCarListComponent } from './Shared/component/rental-car-list/rental-car-list.component';
import { AppointmentDatePickerComponent } from './Shared/component/appointment-date-picker/appointment-date-picker.component';
import { LoaderComponent } from './Shared/common_components/loader/loader.component';
import { PageNotFoundComponent } from './Shared/common_components/page-not-found/page-not-found.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LanguageComponent } from './Shared/common_components/language/language.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { MgPriceFormatPipe } from './Shared/pipe/priceFormat';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DealerSelectionComponent } from './Modules/dealer-selection/dealer-selection.component';
import { CarServiceListComponent } from './Modules/car-service-list/car-service-list.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { CustomerRegistrationComponent } from './Shared/component/customer-registration/customer-registration.component';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,

    MobileVerificationComponent,
    OtpVerificationComponent,
    CarListComponent,
    CarServiceComponent,
    ConfirmBookingComponent,
    BookingSummaryComponent,
    LoaderComponent,
    LanguageComponent,
    DealerDetailComponent,
    DealerLocationComponent,
    DealerListComponent,
    RentalCarListComponent,
    AppointmentDatePickerComponent,
    PageNotFoundComponent,
    ModalComponent,
    MgDecimalValuePipe,
    NumberDirective,
    MgPriceFormatPipe,
    DealerSelectionComponent,
    CarServiceListComponent,
    PrivacyPolicyComponent,
    CustomerRegistrationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CarouselModule,
    PdfViewerModule,
    MalihuScrollbarModule.forRoot(),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyANzieW0BymrMPGnmjBl3AWyilA79xoIao'
    // }),
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      maxOpened: 2,
      newestOnTop: true,
      disableTimeOut: true,
      tapToDismiss: false,
      closeButton: true,
      // toastClass: 'toast border-red',
    }),
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    ModalService,
    TranslateService,
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
